<mat-toolbar>
  <span>
    Configure Tree For - {{treeFieldParentPropertyName}}
  </span>
</mat-toolbar>

<div class="container">
  <form>
    @if (isLoading) {
      <mat-card>
        <mat-spinner></mat-spinner>
      </mat-card>
    }

    @if (!isLoading) {
      <div>
        <mat-card>
          <mat-card-title>
            Add Linked Fields to Configuration
          </mat-card-title>
          <mat-card-content>
            <mat-card-subtitle>
              If the configuration is empty then all linked fields will appear in the dropdown,
              otherwise child linked fields of the most recently added linked field will appear.
            </mat-card-subtitle>
            <mat-form-field>
              <mat-label>
                Select a linked field to add to the tree
              </mat-label>
              <mat-select [(ngModel)]="selectedLinkedField"
                name="selectableLinkedFields">
                @for (linkedField of selectableLinkedFields; track linkedField) {
                  <mat-option
                    [value]="linkedField">
                    {{ linkedField.FieldName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <p>
              <button mat-raised-button
                type="button"
                color="primary"
                (click)="addNewLink()"
                [disabled]="!selectedLinkedField">
                Add New Link
              </button>
            </p>
          </mat-card-content>
        </mat-card>
        <mat-card>
          <mat-card-title>
            Configured Linked Fields
          </mat-card-title>
          <mat-card-content>
            <mat-card-subtitle>
              Configured tree fields are displayed vertically in the order in which they are added.
              If you delete a field from the configuration then all it's child linked fields will be removed.
            </mat-card-subtitle>
            @if (linkedFieldTreeMappings.length > 0) {
              <div>
                @for (treeField of linkedFieldTreeMappings; track treeField; let treeFieldIndex = $index) {
                  <div>
                    @if (treeFieldIndex > 0) {
                      <div
                        color="primary"
                        class="material-icons">
                        arrow_downward
                      </div>
                    }
                    <div>
                      {{getDisplayName(treeField)}}
                      <button color="warn"
                        mat-icon-button
                        type="button"
                        (click)="removeFieldFromConfiguration(treeField)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
            @if (linkedFieldTreeMappings.length < 1) {
              <mat-card-subtitle>
                No linked fields are currently configured
              </mat-card-subtitle>
            }
          </mat-card-content>
        </mat-card>
        <mat-card>
          <button mat-raised-button
            type="button"
            color="accent"
            (click)="saveConfiguration(treeField)"
            [disabled]="linkedFieldTreeMappings.length < 1 || isSaving">
            Save
          </button>
        </mat-card>
      </div>
    }
  </form>
</div>